import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const integrationsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createIntegrations',
        popover: {
          title: 'Create New Integration',
          description:
            'Click here to set up a new integration. Integrations allow your system to connect with external tools and services for seamless data exchange.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.integrationsInformation',
        popover: {
          title: 'Integration Information',
          description:
            'This section provides details about the current integrations, including their status, configuration, and any issues that may need attention.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.syncIntegrations',
        popover: {
          title: 'Sync Integrations',
          description:
            'Use this feature to manually synchronize your integrations. This ensures that data between your system and the integrated services is up-to-date.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.hardSyncIntegrations',
        popover: {
          title: 'Hard Sync Integrations',
          description:
            'Perform a hard sync to force a complete data refresh between your system and the integrated services. This is useful when resolving synchronization issues.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.sharePointIntegrations',
        popover: {
          title: 'SharePoint Integration',
          description:
            'Manage your SharePoint integration settings here. This allows for seamless document management and collaboration through SharePoint.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.resyncIntegrations',
        popover: {
          title: 'Re-sync Integrations',
          description:
            'Click here to re-sync your integrations if you notice any discrepancies in data or functionality.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.integrationsMainTableData',
        popover: {
          title: 'Integrations Overview',
          description:
            'This table displays all integrations currently set up in the system. You can view, edit, or manage each integration from here.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default integrationsDriverObj;
